import React from 'react';
import InfoHint from './InfoHint';

export default function MailboxPicker({ accounts, selected, onChange, hint, t }) {
  const toggle = (id) =>
    onChange(selected.includes(id) ? selected.filter((a) => a !== id) : [...selected, id]);

  return (
    <div className="campaign-field">
      <label>
        {t('outreach.campaign.mailboxes')}
        <InfoHint text={hint} />
      </label>
      <div className="campaign-checkboxes">
        {accounts.map((account) => (
          <label key={account.id} className="campaign-checkbox">
            <input type="checkbox" checked={selected.includes(account.id)} onChange={() => toggle(account.id)} />
            {account.email}
          </label>
        ))}
      </div>
    </div>
  );
}
